import Clipboard from "clipboard";

function toggleSuccessBtn(btn) {
  btn.classList.remove("btn-info");
  btn.classList.add("btn-success");
  const oldText = btn.textContent;
  btn.textContent = "Copied!";
  setTimeout(() => {
    btn.classList.add("btn-info");
    btn.classList.remove("btn-success");
    btn.textContent = oldText;
  }, 2000);
}

function toggleErrorBtn(btn) {
  btn.classList.remove("btn-info");
  btn.classList.add("btn-danger");
  const oldText = btn.textContent;
  btn.textContent = "Error";
  setTimeout(() => {
    btn.classList.add("btn-info");
    btn.classList.remove("btn-success");
    btn.textContent = oldText;
  }, 2000);
  setTimeout(() => {
    btn.classList.add("btn-info");
    btn.classList.remove("btn-danger");
    btn.textContent = oldText;
  }, 2000);
}

export function setupTemplateClipboard() {
  const clipboard = new Clipboard("#copy-template-btn");
  const btn = document.querySelector("#copy-template-btn");

  clipboard.on("success", function (e) {
    toggleSuccessBtn(btn);
    e.clearSelection();
  });

  clipboard.on("error", function (e) {
    toggleErrorBtn(btn);
  });
}

function fileRefClipboard(btnSelector, targetSelector) {
  try {
    const copyBtn = document.querySelector(btnSelector);
    const fileText = document.querySelector(targetSelector);
    const clipboard = new Clipboard(btnSelector);

    var majorMinor = window.JTComponents.version.split(".")[0];
    majorMinor += "." + window.JTComponents.version.split(".")[1];

    fileText.textContent = fileText.textContent.replace("$$$", majorMinor);
    clipboard.on("success", function (e) {
      toggleSuccessBtn(copyBtn);
      e.clearSelection();
    });

    clipboard.on("error", function (e) {
      toggleErrorBtn(copyBtn);
    });
  } catch (err) {
    console.error(err);
  }
}

export function setUpFileClipboards() {
  // fileRefClipboard("#css-theme-copy", "#css-theme-file code");
  // fileRefClipboard("#js-theme-copy", "#js-theme-file code");
  // fileRefClipboard("#css-theme-copy-uat", "#css-theme-file-uat code");
  // fileRefClipboard("#js-theme-copy-uat", "#js-theme-file-uat code");
}
